import Swiper from "swiper";
import { A11y, FreeMode, Scrollbar } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-products").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  new Swiper(container, {
    modules: [A11y, FreeMode, Scrollbar],
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 700,
    centerInsufficientSlides: true,
    freeMode: {
      enabled: true,
      momentumRatio: 0.8,
    },
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
        scrollbar: {
          enabled: numSlides > 2,
        },
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 24,
        scrollbar: {
          enabled: numSlides > 2,
        },
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 32,
        scrollbar: {
          enabled: numSlides > 3,
        },
      },
    },
  });
});
